export default {
  label: '人力资源业务伙伴',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '人力资源业务伙伴是连接业务部门与人力资源部门的桥梁，负责为业务部门提供人力资源支持，推动组织目标的实现',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '与直线经理合作，了解业务需求，预测未来技能需求',
          id: '0-2-1',
        },
        {
          label: '提供人力资源咨询服务，协助业务部门解决人才问题',
          id: '0-2-2',
        },
        {
          label: '管理关键员工的继任计划，识别和管理高潜力人才',
          id: '0-2-3',
        },
        {
          label: '支持领导力发展计划的实施，提供非货币福利建议',
          id: '0-2-4',
        },
        {
          label: '协助直线经理进行员工入职、离职和退休流程管理',
          id: '0-2-5',
        }
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '至少5年的人力资源相关经验，其中2年以上业务伙伴经验',
          id: '0-3-1',
        },
        {
          label: '出色的沟通能力，能够清晰传达复杂信息',
          id: '0-3-2',
        },
        {
          label: '强大的商业洞察力和领导技能',
          id: '0-3-3',
        },
        {
          label: '熟悉HRIS系统和数据分析工具',
          id: '0-3-4',
        }
      ],
    }
  ],
};